import axios, {AxiosError, AxiosResponse} from "axios";
import { MenuResponse } from "../../interface/Server";

// {
//     "code": 10000,
//     "data": {
//       "comments": "Default menu config",
//       "configId": 1,
//       "key": "menu",
//       "parentId": 0,
//       "value": "{'asset': {'title': 'Asset','create': 'Create','query': 'Query'},'generalProject': {'title': 'General Project'}}"
//     },
//     "msg": "OK"
//  }

export const getByPath = () => axios.get(`/config/getByPath?path=menu.en-US`,).then((res: AxiosResponse) => res.data as MenuResponse).catch((err: AxiosError) => console.log(err.message));
